import {defaultDirection} from '../constants/config';
import moment from 'moment'
import {
  _bookingStatus,
  _orderItemStatus,
  _goodsType,
  _agentPaymentMethod,
  _orderStatus, _storeType
} from '../constants/common'

export const addCommas = nStr => {
  nStr += ''
  var x = nStr.split('.')
  var x1 = x[0]
  var x2 = x.length > 1 ? '.' + x[1] : ''
  var rgx = /(\d+)(\d{3})/
  while(rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2')
  }
  return x1 + x2
}

export const mapOrder = (array, order, key) => {
  array.sort(function(a, b) {
    var A = a[key]
    var B = b[key]
    if(order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1
    } else {
      return -1
    }
  })
  return array
}

export const getDateWithFormat = () => {
  const today = new Date()
  let dd = today.getDate()
  let mm = today.getMonth() + 1 // January is 0!

  var yyyy = today.getFullYear()
  if(dd < 10) {
    dd = '0' + dd
  }
  if(mm < 10) {
    mm = '0' + mm
  }
  return dd + '.' + mm + '.' + yyyy
}

export const getCurrentTime = () => {
  const now = new Date()
  return now.getHours() + ':' + now.getMinutes()
}

export const ThemeColors = () => {
  let rootStyle = getComputedStyle(document.body)
  return {
    themeColor1: rootStyle.getPropertyValue('--theme-color-1').trim(),
    themeColor2: rootStyle.getPropertyValue('--theme-color-2').trim(),
    themeColor3: rootStyle.getPropertyValue('--theme-color-3').trim(),
    themeColor4: rootStyle.getPropertyValue('--theme-color-4').trim(),
    themeColor5: rootStyle.getPropertyValue('--theme-color-5').trim(),
    themeColor6: rootStyle.getPropertyValue('--theme-color-6').trim(),
    themeColor1_10: rootStyle.getPropertyValue('--theme-color-1-10').trim(),
    themeColor2_10: rootStyle.getPropertyValue('--theme-color-2-10').trim(),
    themeColor3_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor4_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor5_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor6_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    primaryColor: rootStyle.getPropertyValue('--primary-color').trim(),
    foregroundColor: rootStyle.getPropertyValue('--foreground-color').trim(),
    separatorColor: rootStyle.getPropertyValue('--separator-color').trim()
  }
}

export const chartTooltip = {
  backgroundColor: ThemeColors().foregroundColor,
  titleFontColor: ThemeColors().primaryColor,
  borderColor: ThemeColors().separatorColor,
  borderWidth: 0.5,
  bodyFontColor: ThemeColors().primaryColor,
  bodySpacing: 10,
  xPadding: 15,
  yPadding: 15,
  cornerRadius: 0.15
};

export const centerTextPlugin = {
  afterDatasetsUpdate: function(chart) {
  },
  beforeDraw: function(chart) {
    var width = chart.chartArea.right
    var height = chart.chartArea.bottom
    var ctx = chart.chart.ctx
    ctx.restore()

    var activeLabel = chart.data.labels[0]
    var activeValue = chart.data.datasets[0].data[0]
    var dataset = chart.data.datasets[0]
    var meta = dataset._meta[Object.keys(dataset._meta)[0]]
    var total = meta.total

    var activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1))
    activePercentage = chart.legend.legendItems[0].hidden
      ? 0
      : activePercentage

    if(chart.pointAvailable) {
      activeLabel = chart.data.labels[chart.pointIndex]
      activeValue =
        chart.data.datasets[chart.pointDataIndex].data[chart.pointIndex]

      dataset = chart.data.datasets[chart.pointDataIndex]
      meta = dataset._meta[Object.keys(dataset._meta)[0]]
      total = meta.total
      activePercentage = parseFloat(((activeValue / total) * 100).toFixed(1))
      activePercentage = chart.legend.legendItems[chart.pointIndex].hidden
        ? 0
        : activePercentage
    }

    ctx.font = '36px Nunito, sans-serif'
    ctx.fillStyle = ThemeColors().primaryColor
    ctx.textBaseline = 'middle'

    var text = activePercentage + '%'
    var textX = Math.round((width - ctx.measureText(text).width) / 2)
    var textY = height / 2
    ctx.fillText(text, textX, textY)

    ctx.font = '14px Nunito, sans-serif'
    ctx.textBaseline = 'middle'

    var text2 = activeLabel
    var textX2 = Math.round((width - ctx.measureText(text2).width) / 2)
    var textY2 = height / 2 - 30
    ctx.fillText(text2, textX2, textY2)

    ctx.save()
  },
  beforeEvent: function(chart, event, options) {
    var firstPoint = chart.getElementAtEvent(event)[0]

    if(firstPoint) {
      chart.pointIndex = firstPoint._index
      chart.pointDataIndex = firstPoint._datasetIndex
      chart.pointAvailable = true
    }
  }
};
export const getDirection = () => {
  let direction = defaultDirection
  if(localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction')
    if(localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl'
  }
};

export const setDirection = localValue => {
  let direction = 'ltr'
  if(localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue
  }
  localStorage.setItem('direction', direction)
};

export const alignTableCenter = {
  tdClass: "text-center align-middle",
  thClass: "text-center align-middle"
};

export const alignTableLeft = {
  tdClass: "text-left align-middle",
  thClass: "text-left align-middle"
};

// export const couponSearchOption = [
//   {label: "전화번호", value: "phone"},
//   {label: "쿠폰번호", value: "coupon-serial"}
// ];

export const currencyFilter = {
  currency: value => {
    if(!value) {
      return 0
    }
    if(typeof (value) === "string") { //혹시나 문자열 형태로 5,000 들어오면 오류 방지를 위해 처리
      let _temp = value.replace(/,/gi, '')
      return parseInt(_temp).toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
      return
    } else if(typeof (value) === "number") {
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
    } else {
      return value
    }
  }
};

export const getOrderStatusText = (orderStatus) => {
  return _orderStatus[orderStatus]
}

export const getAgentPaymentMethodText = (agentPaymentMethod) => {
  return _agentPaymentMethod[agentPaymentMethod]
}

export const getBookingStatusText = (bookingStatus) => {
  return _bookingStatus[bookingStatus]
}


export const getStoreType = (storeType) => {
  return _storeType[storeType]
}

export const storeTypeList = [
  {label: '뷔페', value: 'Buffet'},
  {label: '서양식', value: 'Western'},
  {label: '한식', value: 'Korean'},
  {label: '중식', value: 'Chinese'},
  {label: '일식', value: 'Japanese'},
  {label: '이탈리안', value: 'Italian'},
  {label: '프렌치', value: 'French'},
  {label: '아시안', value: 'Asian'},
  {label: '멕시칸', value: 'Mexican'},
  {label: '퓨전', value: 'Fusion'},
  {label: '디저트', value: 'Dessert'},
  {label: '캠핑&바비큐', value: 'Barbecue'},
  {label: '카페&베이커리', value: 'Bakery'},
  {label: '펍&바', value: 'Pub'},
  {label: '홈파티', value: 'HomeParty'},
  {label: '테이크아웃', value: 'Takeout'},
  {label: '스파', value: 'Spa'},
  {label: '기타', value: 'Etc'}
]

export const getGoodsTypeStr = (val) => {
  if (val == "MobileCoupon") {
    return "모바일쿠폰";
  } else if (val == "BookingCoupon") {
    return "예약필수쿠폰";
  } else if (val == "Booking") {
    return "예약";
  } else if (val == "MoneyCoupon") {
    return "모바일금액권";
  } else if (val == "CashCoupon") {
    return "캐시권";
  } else if (val == "Combined") {
    return "결합 상품";
  } else if (val == 'StoreBooking') {
    return '매장예약';
  }else if (val == 'PointCoupon') {
    return '포인트권';
  }
}



export const DateFormat = (date, frmt, week = false) => {
  if (date == null || date == "") {
    return "";
  }
  var days = moment(date).format(frmt);
  if (week) {
    var wkidx = moment(date).day();
    return days + " (" + weekname[wkidx] + ")";
  } else {
    return days;
  }
}
export const getPercent = (sales, target) => {
  if (target == null || target == 0) {
    return "";
  } else {
    var pval = sales * 100 / target;
    return pval.toFixed(2) + "%";
  }
}

import Vue from 'vue';
export const eventBus = new Vue();
